export default function CtaSection() {
  const jump = (id: string) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });

  return (
    <section className="bg-background-50 px-6 py-14 md:px-8 md:py-20">
      <div className="mx-auto max-w-6xl overflow-hidden rounded-2xl border border-primary-200 bg-primary-50">
        <div className="grid grid-cols-1 items-center gap-8 p-7 md:grid-cols-[1.4fr_1fr] md:p-12">
          <div>
            <span className="inline-flex items-center gap-2 font-label text-xs uppercase tracking-[0.2em] text-primary-600">
              <i className="ri-heart-3-line"></i>
              从这里开始
            </span>
            <h2 className="mt-3 font-heading text-2xl font-semibold leading-snug text-foreground-950 md:text-3xl">
              恋爱这件事，值得认真练习
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-700 md:text-base">
              挑一个你现在最需要的方向开始：想提升相处方式，就从恋爱技巧读起；准备去约会，就先看约会攻略；心里有困惑，也许情感咨询里正好有答案。
            </p>
            <div className="mt-7 flex flex-wrap gap-3">
              <button
                type="button"
                onClick={() => jump("skills")}
                className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-3 font-label text-sm text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600 cursor-pointer"
              >
                <i className="ri-lightbulb-line"></i>
                从恋爱技巧开始
              </button>
              <button
                type="button"
                onClick={() => jump("consult")}
                className="inline-flex items-center gap-2 rounded-md border border-primary-300 bg-background-50 px-5 py-3 font-label text-sm text-primary-700 whitespace-nowrap transition-colors hover:bg-primary-100 cursor-pointer"
              >
                <i className="ri-chat-heart-line"></i>
                看看情感咨询
              </button>
            </div>
          </div>

          <div className="rounded-xl border border-primary-200/80 bg-background-50 p-6">
            <p className="font-label text-xs text-foreground-500">本期推荐阅读</p>
            <ul className="mt-3 space-y-3">
              {["第一次约会别踩的五个坑", "对方忽冷忽热的三个可能", "把「你总是」换成「我希望」"].map((title) => (
                <li key={title}>
                  <button
                    type="button"
                    onClick={() => jump("articles")}
                    className="flex w-full items-start gap-2 text-left text-sm leading-relaxed text-foreground-800 transition-colors hover:text-primary-600 cursor-pointer"
                  >
                    <i className="ri-arrow-right-circle-line mt-0.5 text-accent-500"></i>
                    {title}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}